import React, { useState } from 'react';
import {
  Button,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import './Worksheet.scss';

function LookupVehicle(props) {
  const [vin, setVin] = useState('');
  const { fetchCar } = props;

  const onChange = e => {
    setVin(e.target.value);
  };

  const onSubmit = e => {
    fetchCar(vin);
    e.preventDefault();
  };

  return (
    <Form className="lookupVehicle form-inline" onSubmit={onSubmit}>
      <FormGroup controlId="vin" className="lookupVin">
        <ControlLabel htmlFor="vin">VIN #</ControlLabel>
        <FormControl type="string" name="vin" value={vin} onChange={onChange} />
      </FormGroup>
      <Button type="submit">Submit</Button>
    </Form>
  );
}

LookupVehicle.propTypes = {
  fetchCar: PropTypes.func,
};

export default LookupVehicle;
